import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export type KpiPeriod = 30 | 90 | 0; // 0 = all time

export const KPI_PERIOD_OPTIONS: { value: KpiPeriod; label: string }[] = [
  { value: 30, label: '30 dagar' },
  { value: 90, label: '90 dagar' },
  { value: 0, label: 'All tid' },
];

export interface ShopKpis {
  orders_count: number;
  new_orders_count: number;
  expected_total_ore: number;
  received_total_ore: number;
  last_order_at: string | null;
  currency: string;
  days: number;
}

const EMPTY_KPIS: ShopKpis = {
  orders_count: 0,
  new_orders_count: 0,
  expected_total_ore: 0,
  received_total_ore: 0,
  last_order_at: null,
  currency: 'SEK',
  days: 30,
};

export function useShopKpis(producerId: string | undefined, days: KpiPeriod = 30) {
  return useQuery({
    queryKey: ['shop-kpis', producerId, days],
    enabled: !!producerId,
    queryFn: async (): Promise<ShopKpis> => {
      const { data, error } = await supabase.rpc('get_shop_kpis_for_producer', {
        p_producer_id: producerId!,
        p_days: days,
      });

      if (error) {
        console.error('[useShopKpis]', error.message);
        return EMPTY_KPIS;
      }

      const d = data as unknown as ShopKpis;
      return {
        orders_count: d?.orders_count ?? 0,
        new_orders_count: d?.new_orders_count ?? 0,
        expected_total_ore: d?.expected_total_ore ?? 0,
        received_total_ore: d?.received_total_ore ?? 0,
        last_order_at: d?.last_order_at ?? null,
        currency: d?.currency ?? 'SEK',
        days: d?.days ?? days,
      };
    },
    staleTime: 60_000,
  });
}
